import React, { useState } from "react";

import usePatients from "./usePatients";
import PatientsTable from "components/pages/patients/table/PatientTable";
import PatientModal from "components/pages/transmissions/modal/patient/PatientModal";
import PatientEnrollModal from "components/common/modals/patientEnrollModal/PatientEnrollModal";

const Patients = (props) => {
  const { role } = props;
  const [rowSelection, setRowSelection] = useState({});

  const {
    enrollPatient,
    isPatientModal,
    isPatientEnrollModal,
    toggleEnrollPatientModal,
  } = usePatients();

  return (
    <>
      {isPatientModal && <PatientModal />}

      {isPatientEnrollModal && (
        <PatientEnrollModal
          role={role}
          modalOpen={isPatientEnrollModal}
          closeModal={() => toggleEnrollPatientModal(false)}
          enrollPatientSubmit={enrollPatient}
          allowInitialRPMModal={false}
        />
      )}

      <PatientsTable
        rowSelection={rowSelection}
        setRowSelection={setRowSelection}
      />
    </>
  );
};

export default Patients;
